import React, {useContext} from "react";
import PageHeader from "../components/PageHeader";
import CurrentCupFixtures from "../components/cup/CurrentCupFixtures";
import CupKnockoutFixtures from "../components/cup/CupKnockoutFixtures";
import { useNavigate } from "react-router-dom";

import { GlobalContext } from "../contexts/GlobalContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";

function CurrentCupFixturesPage() {
    const { globalSeasonId, globalGameweek, globalActiveCup } =
    useContext(GlobalContext);
    const navigate = useNavigate();

    const handleTitleClick = () => {
        console.log("Here");
        
        navigate("/cup");
    };

    return (
        <div className="cup-fixtures">
            <PageHeader pageTitle="Cup Fixtures" icon={faTrophy} />
            <CurrentCupFixtures seasonId={globalSeasonId} activeCup={globalActiveCup} gameweek={globalGameweek} />
            <CupKnockoutFixtures seasonId={globalSeasonId} activeCup={globalActiveCup} />
        </div>
    )
}

export default CurrentCupFixturesPage;